(function ($, Global) {
    var moreContent = false;
    var newSearch = true;
    var urlParams = new UrlParams();

	var SearchPage = function (searchModel, veilleModel) {
		this.searchModel = searchModel;
		this.veilleModel = veilleModel;
	};

	SearchPage.prototype.initEvents = function () {
		
		this.publishers();
		this.subscribers();
	}

	SearchPage.prototype.publishers = function () {
		var self = this;

        $(document).ready(function () {
            if (urlParams.getParam('sqe')) $.Topic('search-new').publish();
			if ($('input[name="searchquerry_base"]').exists()) {				
				self.searchModel.term = $('input[name="searchquerry_base"]').val();
			}
		})

        $(document).on('click', '.page .search-button', function () {      
            $.Topic('search-new').publish($(this).closest('.searchInput').find('input[name="searchquerry"]').val().replace(/@/g, '&#64;'));
            $(document).find('body, .menuright-filter, .menuright-backdrop').removeClass('in');
        });

        $(document).on('click', '.page #clearButtonSearch', function () {
            $(this).closest('.input-group').find('input[name="searchquerry"]').val('');
        });

        $(document).on('keypress', '.page input[name="searchquerry"]', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                $.Topic('search-new').publish(e.target.value.replace(/@/g, '&#64;'));
			}
        });

        $(document).on('change', '.page input[name="searchquerry"]', function (e) {
            $('input[name="searchquerry"]').not(e.target).val(e.target.value)
        });

        $(document).on('click', '.btn-veille-new', function () {
            var data = self.getData();
            var isSommaireRubrique = $('input[name="IsSommaireRubrique"]').exists() && $('input[name="Publications"]').exists();
            var isFeuilleton = $('input[name="IsFeuilleton"]').exists();
            var isVeillePays = $('input[name="IsVeillePays"]').exists();

            if (isSommaireRubrique) {
                data['IsSommaireRubrique'] = $('input[name="IsSommaireRubrique"]').val() === 'true';
                data['Publications'] = [$('input[name="Publications"]').val()];
                data['TermesRecherches'] = $('input[name="TermesRecherches"]').val();
            }
            else if (isFeuilleton) {
                data['IsFeuilleton'] = $('input[name="IsFeuilleton"]').val() === 'true';
                data['TermesRecherches'] = $('input[name="TermesRecherches"]').val();
                data['Dociid'] = $('input[name="Dociid"]').val();
            }
            else if (isVeillePays) {
                data['TermesRecherches'] = $('input[name="TermesRecherches"]').val();
                data['IsVeillePays'] = $('input[name="IsVeillePays"]').val() === "true";
            }
            else {
                data['TermesRecherches'] = self.searchModel.term;
            }
            if ($('input[name="Nom"]').exists())
                data['Nom'] = $('[name="Nom"]').val();

            $.Topic('veille-new').publish(data, function () { });
		});

		$(document).on('click', '.btn-more-results', function () {
			$.Topic('search-more').publish();
        });

        $(document).on('click', '#btnResultatsSupplementairesFeuilleton', function () {
            $.Topic('display-more-feuilleton').publish();
        });		
	}

	SearchPage.prototype.subscribers = function () {
		var self = this;

        $.Topic('search-new').subscribe(function (input) {
            var data = self.getData(input);
            data = self.setParams(data); 

            moreContent = false;
            self.searchModel.term = data['searchquerry'];
			self.searchModel.pagination = 1;

			$('input[name="searchquerry_base"]').val(self.searchModel.term);

			if (!$('.page').hasClass('loading')) $.Topic('loader-search-show').publish('.page');

			self.searchModel.getResultsPrimary(data, self.callbackResultsPrimary);

            if ($('.page-recherche').exists()) {
                $.Topic('loader-search-show').publish('aside');
                self.searchModel.getResultsSecondary(data, self.callbackResultsSecondary);
            }
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
		});

		$.Topic('search-more').subscribe(function () {
            var data;
            var currentScroll = $(window).scrollTop();

			moreContent = true;
            self.searchModel.pagination += 1;
            data = self.getData();
            data = self.setParams(data);           

            if (!$('.page').hasClass('loading')) $.Topic('loader-search-show').publish();

            self.searchModel.getResultsPrimary(data, function (data) {
                self.callbackResultsPrimary(data);
                $(window).scrollTop(currentScroll);
            });
		});

		$.Topic('filters-changed').subscribe(function () {
            self.searchModel.pagination = 1;
            if (window.location.pathname == '/free') return window.location.reload();
			$.Topic('search-new').publish();
        });

        $.Topic('display-more-feuilleton').subscribe(function () {
            var page = parseInt($(document).find('.page-feuilleton .btn-more-container input[name="page"]').val())
            var $page = $('.page-feuilleton');
            $.Topic('loader-show').publish($page);

            $.ajaxPost(window.location.pathname + '/refresh', page)
                .done(function (result) {
                    Global.ajaxCallback({
                        results: result,
                        success: self.callbackMoreFeuilletons
                    })
                });
        });
	}

    SearchPage.prototype.getData = function (input) {
        urlParams = new UrlParams();

		var self = this;
		var $input = $('.page input[name="searchquerry"]');
        var data = urlParams.getParams();

		data['ListType'] = $('[name="ListType"]').val();
        data['RequestedPage'] = self.searchModel.pagination;
        
        data['searchquerry'] = input || $input.val();

		return data;
    }

    SearchPage.prototype.setParams = function (data) {
        var paramList = ['Section', 'RegionList', 'Theme', 'Secteur', 'Publication'];

        for (var i = 0; i < paramList.length; i++) {
            if (data[paramList[i]] && typeof data[paramList[i]] === 'string') {
                data[paramList[i]] = [data[paramList[i]]];
            }
        }

        return data;
    }

	SearchPage.prototype.callbackResultsPrimary = function (data) {
        var params = data.data;
        $('.results-title-container').removeClass('hidden');

        handleShowResultats(params);
		
        $('.btn-more-container, .btn-more-results,.recherche:eq(1)')[!params.hasMoreResults ? 'addClass' : 'removeClass']('hidden');
		$('[data-toggle="tooltip"]').tooltip();

        handleNbResultats(params);

		if ($('.page-recherche').exists()) {
            $('span.results-number').html(params.nombreResultats);
            $('span.search-terms').html(params.searchQuerry.replaceAll(/(^\")|(\"$)/g, ""));
        }

        handleResultatsParRubrique(params);

        handleFiltreParRegion(params);
        
        if (params.searchEncoded && !newSearch && $('.page-recherche').exists()) {
            urlParams.setParam('sqe', params.searchEncoded);
        }
        newSearch = false;
        resetOwlCarousel();
	}

	SearchPage.prototype.callbackResultsSecondary = function (data) {
		$('.sidenav aside').html(data.data.html);
		$('[data-toggle="tooltip"]').tooltip();
    }

    SearchPage.prototype.callbackMoreFeuilletons = function (res) {
        $('.page-feuilleton .timeline').append(res.data.html);
        var page = $(document).find('.page-feuilleton .btn-more-container input[name="page"]').val();
        $(document).find('.page-feuilleton .btn-more-container input[name="page"]').val(parseInt(page) + 1);
        $('.page-feuilleton .btn-more-container')[!res.data.hasMoreArticles ? 'addClass' : 'removeClass']('hidden');
        resetOwlCarousel();
    }

    function handleShowResultats(params) {
        if ($('.list-articles').length == 2 && params.cesureResultats) {
            if (moreContent) {
                $('.list-articles').eq(1).append(params.html);
            } else {
                $('.list-articles').empty();
                $('.list-articles').eq(0).html(params.html);
                $('.mainnav .list-articles article').each(function (i) {
                    if (i >= params.cesureResultats) {
                        $(this).appendTo($('.list-articles').eq(1))
                    }
                });
            }
        } else if ($('.results-container').exists() && !moreContent) {
            $('.results-container').html(params.html);
        } else {
            $('.mainnav div.list-articles').last()[moreContent ? 'append' : 'html'](params.html);
        }
    }

    function handleNbResultats(params) {
        if (params && params.hasOwnProperty('nombreResultats') && $('#infoNoResults').exists()) {
            if (params['nombreResultats'] === '0') {
                $('#infoNoResults').removeClass('hidden');
            } else {
                $('#infoNoResults').addClass('hidden');
            }
        }
    }

    function handleResultatsParRubrique(params) {
        if (params && params.resultatsParRubrique) {
            for (var k in params.resultatsParRubrique) {
                if (!$('[data-search="' + k + '"]').exists()) continue;

                $('[data-search="' + k + '"]').each(function () { showNbResults(this, params, k) });
            }
        }
    }

    function handleFiltreParRegion(params) {
        if (params && params.hasOwnProperty('paysFiltreParRegion') && $.isArray(params.paysFiltreParRegion) && params.paysFiltreParRegion.length > 0) {
            var paramCountry = urlParams.getParam('Country')

            $('.formFilters select[name="Country"]').each(function () {
                var $el = $(this)
                $el.find('option:gt(0)').remove();
                $.each(params.paysFiltreParRegion, function (key, val) {
                    var optionEl = $('<option></option>')
                        .attr('data-search', val)
                        .attr('selected', (paramCountry === val))
                        .text(val)
                    $el.append(optionEl)
                })
            });
        }
    }

    function showNbResults(el, params, field) {
        $(el).siblings('label').find('.nb-result').remove();
        if (params.resultatsParRubrique[field] != '0') $(el).siblings('label').append('<span class="nb-result"> (' + params.resultatsParRubrique[field] + ')</span>');
    }

    function resetOwlCarousel() {
        $('.carousel-multi-items .owl-carousel').owlCarousel({
            loop: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                    loop: false,
                    dots: true
                },
                680: {
                    items: 2,
                    nav: false,
                    dots: true
                },
                1000: {
                    items: 3,
                    nav: true,
                    dots: false
                }
            }
        });
    }

	Global.SearchPage = SearchPage;
}(jQuery, window));